import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "icon", "iconSpacing", "iconOffset"];
import React from 'react';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
function Hint(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'info' : _ref$icon,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === void 0 ? 'xs' : _ref$iconSpacing,
    iconOffset = _ref.iconOffset,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, otherProps, /*#__PURE__*/React.createElement(Flag, {
    align: "top",
    spacing: iconSpacing,
    token: /*#__PURE__*/React.createElement(Icon, {
      dimmed: true,
      name: icon,
      color: icon === 'warning' ? 'negative' : undefined
    }),
    tokenOffset: iconOffset
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s",
    id: id
  }, children)));
}
export default Hint;